"use client";
import styled from "../../../client-utils/styled/index.js";
import Box from "../../../components/atoms/Box/index.js";
import Typography from "../../../components/atoms/Typography/index.js";
import MenuItem from "../../../components/atoms/MenuItem/index.js";
import ListItemIcon from "../../../components/atoms/ListItemIcon/index.js";
import IconAtom from "../../../components/atoms/Icon/index.js";
import { SINGLE, TRIPLE } from "../../../constants/numbers.consts.js";
// root, wrapper, endIcon, text
export const coreComponentName = "SdbCardMenuItem";
export const Root = styled(MenuItem, { name: coreComponentName, slot: "Root" })(({ theme }) => ({
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    borderImageSlice: SINGLE,
    borderImageSource: `linear-gradient(to left, white 0 5%, ${theme.vars.palette.divider} 5% 95%, white 95% 100%)`,
}));
export const Wrapper = styled(Box, { name: coreComponentName, slot: "Wrapper" })({
    display: "flex",
    overflow: "hidden",
    width: "100%",
});
export const Text = styled(Typography, { name: coreComponentName, slot: "Text" })({ flexGrow: SINGLE });
export const Icon = styled(IconAtom, { name: coreComponentName, slot: "Icon" })(({ theme }) => ({
    color: theme.vars.palette.surface.onVariant,
}));
export const StartIcon = styled(ListItemIcon, { name: coreComponentName, slot: "StartIcon" })();
export const EndIcon = styled(ListItemIcon, { name: coreComponentName, slot: "EndIcon" })();
export const BadgeIcon = styled(ListItemIcon, { name: coreComponentName, slot: "BadgeIcon" })(({ theme }) => ({
    paddingLeft: theme.spacing(TRIPLE),
    paddingTop: theme.spacing(TRIPLE),
}));
